import { render, staticRenderFns } from "./add-photo.component.vue?vue&type=template&id=bf6c6b28"
import script from "./add-photo.component.vue?vue&type=script&lang=js"
export * from "./add-photo.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports